import { Button, FormControl, Input, InputGroup, InputLeftElement, Stack, Text } from "@chakra-ui/react"
import { FaEnvelope } from "react-icons/fa"

interface EmailInputStepProps {
    email: string
    setEmail: (email: string) => void
    onSubmit: () => void
    onBackToLogin: () => void
    isLoading: boolean
    buttonColor: string
    errorMessage?: string
}

const EmailInputStep = ({ email, setEmail, onSubmit, onBackToLogin, isLoading, buttonColor, errorMessage }: EmailInputStepProps) => {
    return (
        <>
            <Stack textAlign={'center'}>
                <Text fontSize='3xl' fontWeight={'300'}>Forgot Password?</Text>
            </Stack>
            <Stack spacing={0} mt={2} mb={5} textAlign={'center'}>
                <Text fontSize='md' fontWeight={'200'}>We can send you a verification code.</Text>
                <Text fontSize='md' fontWeight={'200'}>Please enter your email address.</Text>
            </Stack>
            <Stack spacing={5}>
                <FormControl isInvalid={!!errorMessage}>
                    <InputGroup>
                        <InputLeftElement pointerEvents='none'>
                            <FaEnvelope />
                        </InputLeftElement>
                        <Input 
                            fontWeight={'200'} 
                            type='email' 
                            autoComplete={'off'} 
                            value={email} 
                            onChange={e => setEmail(e.target.value)}
                            borderColor={errorMessage ? 'red.500' : undefined}
                        />
                    </InputGroup>
                    {errorMessage && (
                        <Text color='red.500' fontSize='sm' mt={2}>
                            {errorMessage}
                        </Text>
                    )}
                </FormControl>
                <Stack>
                    <Button
                        isLoading={isLoading}
                        loadingText={'Submitting'}
                        onClick={onSubmit}
                        bg={buttonColor}
                        color={'white'}
                        _hover={{
                            bg: 'blue.400',
                        }}
                        isDisabled={!email}>
                        Submit
                    </Button>
                    <Button
                        bg={'white'}
                        onClick={onBackToLogin}
                        color={'blue.400'}
                        _hover={{
                            bg: 'white',
                        }}>
                        Back to Login
                    </Button>
                </Stack>
            </Stack>
        </>
    )
}

export default EmailInputStep
